import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';

import Layout from '@/components/layout/Layout';
import ErrorDuplicateApplyContent from '@/components/tax-refund/common/view/ErrorView/ErrorDuplicateApplyContent';
import { COMMON_PATHS } from '@/lib/constants/paths';

const ErrorPage = () => {
  const router = useRouter();

  const handleClickExit = () => {
    router.push({
      pathname: `${COMMON_PATHS.환급조회목록}`,
      query: router.query
    });
  };
  return (
    <AuthGuard>
      <Layout
        rightTextButton={{
          label: '나가기',
          state: 'gray',
          onClick: handleClickExit
        }}
      >
        <ErrorDuplicateApplyContent />
      </Layout>
    </AuthGuard>
  );
};

export default ErrorPage;
